import { useUIDSeed } from 'react-uid';
export default function useUniqueId(prefix) {
  var seed = useUIDSeed();
  return "".concat(prefix, "-").concat(seed(prefix));
}